// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2EEHs","notes":"Notes_notes__3uBh8","note":"Notes_note__1VgNU","markdown":"Notes_markdown__3HKnk"};